module.exports = __webpack_public_path__ + "img/black.8ddc154f.svg";